// import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
// import { TApiResponse } from "../../TApiResponse"
import {
  TNinusiUriageZissekiGetListReq,
  TNinusiUriageZissekiGetListRes,
} from "./TNinusiUriageZisseki"

/**
 * 荷主売上実績に対するAPIリクエスト用サービス
 *
 * @export
 * @class NinusiUriageZissekiService
 * @extends {ConnectApi}
 */
export default class NinusiUriageZissekiService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TNinusiUriageZissekiGetListReq} params
   * @param {(param: TApiResponse<TNinusiUriageZissekiGetListRes[]>) => any} resolve
   * @param {(param: TApiResponse<TNinusiUriageZissekiGetListRes[]>) => any} reject
   * @memberof MenuService
   */
  getList = async (params: TNinusiUriageZissekiGetListReq) => {
    try {
      // const res: AxiosResponse<TApiResponse<TNinusiUriageZissekiInfoGetRes[]>> =
      // await this.getInner(`/truckcontrol/NinusiUriageZisseki`, params)
      //return res.data
      let tmpNen = params.年
      if (tmpNen?.toString() === "2021") {
        return {
          data: [],
        }
      }
      return {
        data: dummyData,
        // data: [],
      }
      //TODO: api実装必要
    } catch (err) {
      throw err
    }
  }
}

//TODO:ダミーデータ

const dummyData: TNinusiUriageZissekiGetListRes[] = [
  {
    荷主ID: 1,
    荷主コード: "14015",
    荷主名: "AGC株式会社　業務グループ",
    売上額: 111222333,
    稼働台数: 140,
    運送料: 111000000,
    付帯料: 222000,
    高速料: 333,
    削除フラグ: 0,
    更新日時: "2021-01-01T00:00:00",
  },
  {
    荷主ID: 2,
    荷主コード: "14020",
    荷主名: "AGCロジスティクス株式会社　愛知営業所",
    売上額: 111222433,
    稼働台数: 140,
    運送料: 111000000,
    付帯料: 222000,
    高速料: 433,
    削除フラグ: 0,
    更新日時: "2021-01-01T00:00:00",
  },
  {
    荷主ID: 3,
    荷主コード: "14025",
    荷主名: "AGCロジスティクス株式会社　鹿島営業所",
    売上額: 111222533,
    稼働台数: 140,
    運送料: 111000000,
    付帯料: 222000,
    高速料: 533,
    削除フラグ: 0,
    更新日時: "2021-01-01T00:00:00",
  },
  {
    荷主ID: 4,
    荷主コード: "14030",
    荷主名: "AGCロジスティクス株式会社　関西営業所",
    売上額: 111222633,
    稼働台数: 140,
    運送料: 111000000,
    付帯料: 222000,
    高速料: 633,
    削除フラグ: 0,
    更新日時: "2021-01-01T00:00:00",
  },
  {
    荷主ID: 5,
    荷主コード: "14035",
    荷主名: "AGCロジスティクス株式会社　高砂営業所",
    売上額: 111222733,
    稼働台数: 140,
    運送料: 111000000,
    付帯料: 222000,
    高速料: 733,
    削除フラグ: 0,
    更新日時: "2021-01-01T00:00:00",
  },
  {
    荷主ID: 6,
    荷主コード: "14040",
    荷主名: "AGCロジスティクス株式会社　東日本営業開発グループ",
    売上額: 111222833,
    稼働台数: 140,
    運送料: 111000000,
    付帯料: 222000,
    高速料: 833,
    削除フラグ: 0,
    更新日時: "2021-01-01T00:00:00",
  },
  {
    荷主ID: 7,
    荷主コード: "14045",
    荷主名: "AGCロジスティクス株式会社　北陸営業所",
    売上額: 111222933,
    稼働台数: 140,
    運送料: 111000000,
    付帯料: 222000,
    高速料: 933,
    削除フラグ: 0,
    更新日時: "2021-01-01T00:00:00",
  },
  {
    荷主ID: 8,
    荷主コード: "14050",
    荷主名: "AGCロジスティクス株式会社　横浜営業所",
    売上額: 111223033,
    稼働台数: 140,
    運送料: 111000000,
    付帯料: 222000,
    高速料: 1033,
    削除フラグ: 0,
    更新日時: "2021-01-01T00:00:00",
  },
  {
    荷主ID: 9,
    荷主コード: "14055",
    荷主名: "aaaaaaaaaa",
    売上額: 111223133,
    稼働台数: 140,
    運送料: 111000000,
    付帯料: 222000,
    高速料: 1133,
    削除フラグ: 0,
    更新日時: "2021-01-01T00:00:00",
  },
  {
    荷主ID: 10,
    荷主コード: "14060",
    荷主名: "bbbbbbbbbbbbb",
    売上額: 111223233,
    稼働台数: 140,
    運送料: 111000000,
    付帯料: 222000,
    高速料: 1233,
    削除フラグ: 0,
    更新日時: "2021-01-01T00:00:00",
  },
]
